import { render } from "./AddMonitorASG.vue?vue&type=template&id=0c898b04&scoped=true"
import script from "./AddMonitorASG.vue?vue&type=script&lang=js"
export * from "./AddMonitorASG.vue?vue&type=script&lang=js"

import "./AddMonitorASG.vue?vue&type=style&index=0&id=0c898b04&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c898b04"],['__file',"src/containers/event/eventSettings/components/AddMonitorASG.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c898b04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c898b04', __exports__)) {
    api.reload('0c898b04', __exports__)
  }
  
  module.hot.accept("./AddMonitorASG.vue?vue&type=template&id=0c898b04&scoped=true", () => {
    api.rerender('0c898b04', render)
  })

}


export default __exports__